// eslint-disable-next-line @typescript-eslint/ban-ts-ignore
// @ts-ignore
import SmoothScroll from 'smooth-scroll';

export const scrollToTopLink = () => {
  (function() {
    const scroll = new SmoothScroll('[data-scroll]', {
      speed: 1000,
      speedAsDuration: true
    });
  })();
};